import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import { overlayActionsChip } from './actions/components/action-btn/styled'

export const PreviewContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 200px;
  border-radius: ${RADII.card};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.primaryExtraLight};
`

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
  border-radius: ${RADII.card};
`

// Row of action buttons pinned to the top-right of the preview — one chip
// surface holding the borderless icon buttons (see `overlayActionsChip`).
export const ActionsRow = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  ${overlayActionsChip}
`

// Semi-transparent while an image is underneath (Enhance/Resize in flight, or a
// new avatar decoding over the previous one) so the current source stays dimly
// visible behind the spinner — same rgba-white convention as DotsLoading /
// LoadingGradient. Solid otherwise (nothing to show through yet).
export const LoadingOverlay = styled.div<{ $hasImage?: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $hasImage }) =>
    $hasImage ? 'rgba(0, 0, 0, 0.4)' : COLORS.primaryExtraLight};
`
